import React from 'react';
import MoneyUtils from '../../../utils/moneyUtils';
import Icon from '../../../components/AppIcon';

const HighDensityListItem = ({ item, onItemClick }) => {
  const isVeg = item?.isVegetarian === true || item?.isVeg === true || item?.veg === true;
  const isOutOfStock = item?.isAvailable === false;
  const hasPortions = item?.portions && item.portions.length > 0;

  // Chunk portions into pairs of 2
  const chunkedPortions = [];
  if (hasPortions) {
    for (let i = 0; i < item.portions.length; i += 2) {
      chunkedPortions.push(item.portions.slice(i, i + 2));
    }
  }

  const formatPriceCompact = (smallestUnit) => {
    const displayAmount = MoneyUtils.toDisplayAmount(smallestUnit);
    const symbol = MoneyUtils.config.symbol || '₹';
    const position = MoneyUtils.config.symbolPosition || 'before';
    return position === 'before' ? `${symbol} ${displayAmount}` : `${displayAmount} ${symbol}`;
  };

  const handleRowClick = () => {
    if (isOutOfStock) return;
    onItemClick(item);
  };

  return (
    <div
      onClick={handleRowClick}
      className={`py-3 px-1 border-b border-gray-100/70 flex gap-3 transition-colors ${
        isOutOfStock
          ? 'opacity-40 cursor-not-allowed'
          : 'cursor-pointer active:bg-gray-50/50'
      }`}
    >
      {/* Veg / Non-Veg Indicator Dot */}
      <div className="pt-1 flex-shrink-0 flex items-center gap-1">
        {isVeg ? (
          <div className="w-3.5 h-3.5 border border-green-600 rounded-sm flex items-center justify-center">
            <div className="w-1.5 h-1.5 rounded-full bg-green-600" />
          </div>
        ) : (
          <div className="w-3.5 h-3.5 border border-red-600 rounded-sm flex items-center justify-center">
            <div className="w-1.5 h-1.5 rounded-full bg-red-600" />
          </div>
        )}
        {(item?.isVegan === true || item?.vegan === true) && (
          <Icon name="Leaf" size={12} color="#16a34a" />
        )}
      </div>

      {/* Item Info & Portions */}
      <div className="flex-1 min-w-0 flex flex-col gap-0.5">
        <div className="flex items-center justify-between gap-2">
          <h4 className="font-bold text-[13px] text-gray-900 leading-snug">
            {item.name ? item.name.charAt(0).toUpperCase() + item.name.slice(1) : ''}
          </h4>
          
          {/* Display Single Price if no portions */}
          {!hasPortions && (
            <span className="text-[12px] font-bold text-gray-900 flex-shrink-0">
              {formatPriceCompact(item.offerPrice || item.price)}
            </span>
          )}
        </div>

        {/* Display Out of Stock text */}
        {isOutOfStock ? (
          <span className="text-[9px] font-bold text-red-600 uppercase tracking-wider mt-0.5">
            Out of Stock
          </span>
        ) : (
          /* Portions Grid/Pairs display */
          hasPortions && (
            <div className="flex flex-col gap-0.5 mt-0.5">
              {chunkedPortions.map((pair, pIdx) => (
                <div key={pIdx} className="flex items-center gap-1.5 text-xs text-gray-500 font-medium leading-normal flex-wrap">
                  {pair.map((portion, idx) => {
                    const displayPrice = formatPriceCompact(portion.price);
                    const portionLabel = portion.name || portion.size || '';
                    return (
                      <React.Fragment key={idx}>
                        {idx > 0 && <span className="text-gray-300 select-none">•</span>}
                        <span className="truncate max-w-[120px]">{portionLabel}</span>
                        <span className="text-gray-900 font-bold ml-1">{displayPrice}</span>
                      </React.Fragment>
                    );
                  })}
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default HighDensityListItem;
